define(["./monitoringInvoiceDeliveryEffectivenessOverviewModule"], function (module) {
    "use strict";

    return module.controller("monitoringInvoiceDeliveryEffectivenessOverviewController", [
        "$scope",
        function ($scope) {
            $scope.currentDashboard =   {
                dashboardSourceId: ""
            };
        }]);
});